import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx.js';

/**
 * A named section on an Arcade chip: white, a 2px ink stroke and hard shadow.
 * Layout passes through, while the shared face stays consistent. Forwarding
 * aria-labelledby keeps the caller's section reachable as a landmark.
 */

export interface PanelProps extends Omit<HTMLAttributes<HTMLElement>, 'className' | 'children'> {
  /** Layout and spacing only. The surface is not the caller's to change. */
  readonly className?: string | undefined;
  readonly children: ReactNode;
}

const PANEL =
  'flex flex-col gap-3 rounded-2xl border-2 border-ink bg-ground-light p-5 shadow-sm shadow-ink ';

export function Panel({ className, children, ...rest }: PanelProps): React.JSX.Element {
  return (
    <section className={cx(PANEL, className)} {...rest}>
      {children}
    </section>
  );
}
